import { useEffect } from "react";
import { X, Download, Play } from "lucide-react";

export const ImageLightbox = ({ src, alt, type = "image", onClose }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose]);

  if (!src) return null;
  return (
    <div data-testid="image-lightbox" className="fixed inset-0 z-[9999] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 fade-up" onClick={onClose}>
      <button data-testid="lightbox-close-btn" onClick={onClose} aria-label="Close" className="absolute top-3 right-3 p-2 rounded-full bg-white/15 hover:bg-white/30 text-white transition-colors">
        <X size={22} />
      </button>
      <a data-testid="lightbox-download-btn" href={src} download={alt || "media"} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} aria-label="Download" className="absolute top-3 right-14 p-2 rounded-full bg-white/15 hover:bg-white/30 text-white transition-colors">
        <Download size={22} />
      </a>
      {type === "video"
        ? <video data-testid="lightbox-video" src={src} controls autoPlay onClick={(e) => e.stopPropagation()} className="max-w-[92vw] max-h-[88vh] rounded-lg shadow-2xl" />
        : <img src={src} alt={alt || ""} onClick={(e) => e.stopPropagation()} className="max-w-[92vw] max-h-[88vh] object-contain rounded-lg shadow-2xl" />}
    </div>
  );
};

export const VideoThumb = ({ src, testId, className, onOpen }) => (
  <div data-testid={testId} onClick={onOpen} className={`relative cursor-zoom-in group ${className || ""}`}>
    <video src={src} muted preload="metadata" className="w-full h-full rounded-lg object-cover pointer-events-none" />
    <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-black/30 group-hover:bg-black/40 transition-colors">
      <div className="p-2.5 rounded-full bg-white/85 shadow"><Play size={18} className="text-slate-900 ml-0.5" fill="currentColor" /></div>
    </div>
  </div>
);
